<template>
  <div id="export_resources">
    <div class="table-wrapper">
        <div>
          请选择时间:
          <el-date-picker
              v-model="value.month_select"
              :data="value.month_select"
              type="monthrange"
              range-separator="-"
              value-format="yyyyMM"
              style="width:250px"
              :clearable="false"
          >
          </el-date-picker>
          <br/><br/><br/>

        </div>
      </div>
  </div>
</template>

<script>
export default {
  props: ["exprotResourcesData"],
  data() {
    return {
      value: this.exprotResourcesData,
    };
  },
  methods: {
  },
};
</script>

<style lang="less" scoped>
#export_resources {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  > .line {
    width: 100%;
    height: 55px;
    display: flex;
    align-items: center;
    > .title {
      width: 20%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      padding-right: 5px;
      box-sizing: border-box;
      font-size: 13px;
    }
    > .value {
      width: auto;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    > .name {
      width: auto;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-left: 5px;
      font-size: 13px;
    }
    > .link {
      width: auto;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-left: 5px;
      color: @activeColor;
      transition: 0.3s;
      font-size: 12px;
      &:hover {
        cursor: pointer;
        text-decoration: underline;
        color: @activeColor;
      }
    }
    .upload_content_value_but-upload {
      > i {
        font-size: 22px;
      }
      font-size: 13px;
      border: 1px solid @boderColor;
      width: auto;
      height: auto;
      padding: 5px 10px;
      border-radius: 3px;
      box-sizing: border-box;
      transition: 0.3s;
      &:hover {
        cursor: pointer;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
        color: @activeColor;
      }
    }
  }
}
</style>
